import React from 'react';
import { withRouteProps } from 'src/@app/hocs/withRouteProps';
import { SplitLayout } from 'src/screens/layout';
// selectors
import { useLanguageSelectors } from 'src/@app/reducers/languageReducer';

const ComingSoonScreen = () => {
  const languageSelectors = useLanguageSelectors();
  const {
    components: {
      headings: { comingSoon },
    },
  } = languageSelectors.getLanguage();
  return (
    <SplitLayout>
      <div className="container-fluid">
        <div className="header-container">
          <section className="page-header">
            <h1 className="page-header-text">{comingSoon}</h1>
          </section>
        </div>
      </div>
    </SplitLayout>
  );
};

export const ComingSoon = withRouteProps(ComingSoonScreen);
